export default __webpack_public_path__ + "static/media/bottom.f5748e5d.png";